import React from 'react'

export function handleTextAreaChanges(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, component) {
  const { formErrors } = component.state
  component.setState({
    formErrors: {
      ...formErrors,
      ...{
        [event.target.id]: component.validationSchema.extract(event.target.id).validate(event.target.value).error,
      },
    },
  })
  component.props.setState(event.target.id, event.target.value)
}

export function handleBasicValueChanges(key, value, component) {
  const { formErrors } = component.state
  component.setState({
    formErrors: {
      ...formErrors,
      ...{
        [key]: component.validationSchema.extract(key).validate(value).error,
      },
    },
  })
  component.props.setState(key, value)
}

export function handleCheckboxChanges(event: React.ChangeEvent<HTMLInputElement>, component) {
  const { formErrors } = component.state
  const value = event.target.checked
  component.setState({
    formErrors: {
      ...formErrors,
      ...{
        [event.target.id]: component.validationSchema.extract(event.target.id).validate(value).error,
      },
    },
  })
  component.props.setState(event.target.id, value)
}

export function handlePasswordConfirmationChanges(
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  component,
  password: string,
) {
  const { formErrors } = component.state

  component.setState({
    formErrors: {
      ...formErrors,
      ...{
        [event.target.id]: component.validationPasswordSchema.validate({
          password,
          passwordConfirm: event.target.value,
        }).error,
      },
    },
  })
  component.props.setState(event.target.id, event.target.value)
}

// todo cannot understand what it is and why we need it.
export function setFieldTouched(event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>, component) {
  const { touchedFields } = component.state
  if (touchedFields.has(event.target.id)) {
    return
  }
  component.setState({
    touchedFields: touchedFields.add(event.target.id),
  })
}

export function setBasicValueTouched(key, component) {
  const { touchedFields } = component.state
  if (touchedFields.has(key)) {
    return
  }
  component.setState({
    touchedFields: touchedFields.add(key),
  })
}
